import { Button, Form, Input, Modal, Select } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionModalSliceDispatch, actionViewerSliceDispatch, pickAFileSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";

function ActionModal() {
    const currentQuestions = useSelector((state: any) => state.pickAFile.questions);
    const currentActions = useSelector((state: any) => state.pickAFile.actions);
    const currentRules = useSelector((state: any) => state.pickAFile.rules);

    const open = useSelector((state: any) => state.actionModal.open);
    const actionToAdd = useSelector((state: any) => state.actionModal.actionToAdd);

    const addModal = useSelector((state: any) => state.actionViewer.addModal);
    const editModal = useSelector((state: any) => state.actionViewer.editModal);
    const currentAction = useSelector((state: any) => state.actionViewer.currentAction);
    const indexOverride = useSelector((state: any) => state.actionViewer.indexOverride);

    const dispatch = useDispatch();

    const { CreateContentsFromStates } = ReduxHelpers();

    const successFailOptions = [
        { key: "success", text: "success", value: "success" },
        { key: "fail", text: "fail", value: "fail" }
    ]
    const funcOptions = [
        { key: "show", text: "show", value: "show" },
        { key: "hide", text: "hide", value: "hide" },
        { key: "require", text: "require", value: "require" },
        { key: "unrequire", text: "unrequire", value: "unrequire" },
        { key: "readonly", text: "readonly", value: "readonly" },
        { key: "readwrite", text: "readwrite", value: "readwrite" },
    ]

    let questionDropDownList = currentQuestions?.map(b => { return ({ key: b.dataKey, text: b.dataKey, value: b.dataKey }) })

    let rulesDropDownList = currentRules?.map(b => {
        return (
            {
                key: parseInt(b.event.type),
                label: b?.name == "" || b?.name == undefined ? parseInt(b.event.type) : b.name,
                value: parseInt(b.event.type)
            }
        )
    }
    )

    let actionValuesToShow = currentAction;

    actionValuesToShow.ruleId = parseInt(actionValuesToShow.event.split("/")[0])
    actionValuesToShow.successFail = actionValuesToShow.event.split("/")[1]

    // Ensure actionId is properly set - use existing actionId if valid (> 0), otherwise use indexOverride
    actionValuesToShow.actionId = actionValuesToShow.actionId && actionValuesToShow.actionId > 0 ? actionValuesToShow.actionId : indexOverride;

    let adder = AddAnAction;
    let editor = EditAnAction;

    const onSubmit = () => {
        // Ensure actionId is set correctly before saving
        const actionToSave = {
            ...actionToAdd,
            actionId: actionToAdd.actionId && actionToAdd.actionId > 0 ? actionToAdd.actionId : indexOverride
        };

        //We are adding a new one
        if (addModal) {
            adder(null, actionToSave)
        }

        //We are editing one
        if (editModal) {
            // Use the original actionId for identification during edit
            const originalActionId = currentAction.actionId && currentAction.actionId > 0 ? currentAction.actionId : indexOverride;
            editor(originalActionId, actionToSave)
        }

        dispatch({ type: actionModalSliceDispatch.setOpen, payload: false })
    }

    const onCancel = () => {
        dispatch({ type: actionModalSliceDispatch.setOpen, payload: false })
    }

    const onChange = (event) => {
        //NOTE: Change actionIds to integers
        let valueToUse = event.target.value;
        if (event.target.id == "actionId") {
            valueToUse = parseInt(event.target.value) || 0; // Ensure we get a valid number
        }

        dispatch({ type: actionModalSliceDispatch.setActionToAdd, payload: { ...actionToAdd, [event.target.id]: valueToUse } })
    }

    const onRuleIdDropDownChange = (value) => {
        actionToAdd.event = value + "/" + (actionToAdd.successFail ?? "")
        dispatch({ type: actionModalSliceDispatch.setActionToAdd, payload: { ...actionToAdd, ['ruleId']: value } })
    }

    const onSuccessFailDropDownChange = (value) => {
        actionToAdd.event = (actionToAdd.ruleId ?? "") + "/" + value
        dispatch({ type: actionModalSliceDispatch.setActionToAdd, payload: { ...actionToAdd, ['successFail']: value } })
    }

    const onFunctionDropDownChange = (value) => {
        dispatch({ type: actionModalSliceDispatch.setActionToAdd, payload: { ...actionToAdd, ['func']: value } })
    }

    const onQuestionsDropDownChange = (value) => {
        dispatch({ type: actionModalSliceDispatch.setActionToAdd, payload: { ...actionToAdd, ['params']: value } })
    }

    function AddAnAction(oldList: any, newAction: any) {
        let listToUse;
        if (oldList) {
            listToUse = oldList;
        } else {
            listToUse = currentActions
        }

        listToUse.push(newAction)

        dispatch({ type: pickAFileSliceDispatch.setActions, payload: listToUse })
        dispatch({ type: actionViewerSliceDispatch.setActionSearchResults, payload: listToUse })

        CreateContentsFromStates({ actions: listToUse });
    }

    function EditAnAction(oldActionId: any, newAction: any) {
        let filteredActions = DeleteAnAction(oldActionId, false)
        AddAnAction(filteredActions, newAction)
    }

    function DeleteAnAction(actionIdToDelete: any, updateState: boolean = true) {
        let filteredActions = currentActions.filter((action: any) => action.actionId != actionIdToDelete);

        if (updateState) {
            dispatch({ type: pickAFileSliceDispatch.setActions, payload: filteredActions })
            CreateContentsFromStates({ actions: filteredActions });
        }

        return filteredActions;
    }

    return (
        <Modal
            title="Action Details"
            footer={null}
            closable={false}
            open={open}
            destroyOnHidden={true}
            onCancel={onCancel}
        >
            <Form
                onFinish={onSubmit}
                preserve={false}
                initialValues={{
                    ["Action ID"]: actionValuesToShow.actionId,
                    ["Rule ID"]: actionValuesToShow.ruleId,
                    ["Success/Fail"]: actionValuesToShow.successFail,
                    ["Function"]: actionValuesToShow.func,
                    ["Questions"]: actionValuesToShow.params,
                }}
            >
                <Form.Item rules={[{ required: true }]} name="Action ID" label="Action ID">
                    <Input id="actionId" type="number" placeholder='Action ID' defaultValue={actionValuesToShow.actionId} onChange={onChange} />
                </Form.Item>
                <Form.Item rules={[{ required: true }]} name="Rule ID" label="Rule ID">
                    <Select
                        placeholder='Select Rule ID'
                        options={rulesDropDownList}
                        defaultValue={actionValuesToShow.ruleId}
                        onChange={onRuleIdDropDownChange}
                    />
                </Form.Item>
                <Form.Item rules={[{ required: true }]} name="Success/Fail" label="Success/Fail">
                    <Select
                        placeholder='Select Success/Fail'
                        options={successFailOptions}
                        defaultValue={actionValuesToShow.successFail}
                        onChange={onSuccessFailDropDownChange}
                    />
                </Form.Item>
                <Form.Item rules={[{ required: true }]} name="Function" label="Function">
                    <Select
                        placeholder='Select Function'
                        options={funcOptions}
                        defaultValue={actionValuesToShow.func}
                        onChange={onFunctionDropDownChange}
                    />
                </Form.Item>
                <Form.Item rules={[{ required: true }]} name="Questions" label="Questions">
                    <Select
                        placeholder='Select Questions'
                        mode="multiple"
                        options={questionDropDownList}
                        defaultValue={actionValuesToShow.params}
                        onChange={onQuestionsDropDownChange}
                    />
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button onClick={onCancel}>
                            Cancel
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    )
}

export default ActionModal;